import { render, staticRenderFns } from "./AppTablePagination.vue?vue&type=template&id=f893f63e"
import script from "./AppTablePagination.vue?vue&type=script&lang=js"
export * from "./AppTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports